import { createAsyncThunk } from "@reduxjs/toolkit";
import apiConfig from "constants/apiConfig";
import { fetchCampaignInsights as fetchCampaignInsightsAPI } from "services/api/campaign";
import { AuthState } from "slices/auth/reducer";
import { ERROR } from "types";
import { CampaignInsightsData, CampaignInsightsSlice } from "types/campaign/insights";
import { getErrorMessage, isFresh } from "utils/helpers";

export const fetchCampaignInsights = createAsyncThunk<{ campaignId: string, campaignInsights: CampaignInsightsData }, { campaignId: string, force?: boolean }, { rejectValue: string }>(
    'campaign/insights',
    async ({ campaignId, force }, { getState, rejectWithValue }) => {
        try {
            const state = getState() as { auth: AuthState, campaignInsights: CampaignInsightsSlice };
            const STALE_TIME = apiConfig.FETCH_CAMPAIGN_INSIGHTS.staleTime;

            const agencyId = state.auth.selectedAgencyId;;
            if (!agencyId) throw new Error("No agency selected!");

            if (!force && isFresh(state.campaignInsights.campaigns[campaignId]?.last_fetched_at ?? null, STALE_TIME)) {
                return rejectWithValue(ERROR.CACHED);
            }

            const campaignInsights = await fetchCampaignInsightsAPI(agencyId, campaignId);

            return { campaignId, campaignInsights };

        } catch (error) {
            return rejectWithValue(getErrorMessage(error, "Failed to fetch campaign insights!"));
        }
    }
)
